import { fetchExactagCustomerData } from "./api"
import * as exactag from "@otto-ec/online-marketing/exactag"

export function trackCustomerData() {
    exactag.registerVerticalDataCallback("customerData", async () => {
        try {
            return await fetchExactagCustomerData()
        } catch (error) {
            console.error("Failed to fetch customer's exactag data:", error)
            return null
        }
    })
}
trackCustomerData()
